(() => {
  // Tabbed product grids
  const initTabs = (root) => {
    root.querySelectorAll('[data-w-tabs]').forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const btns = wrap.querySelectorAll('.w-tabs__btn');
      const panels = wrap.querySelectorAll('.w-tabs__panel');
      const more = wrap.querySelector('[data-w-more]');
      btns.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          btns.forEach((b, j) => {
            b.setAttribute('aria-selected', i === j ? 'true' : 'false');
            b.tabIndex = i === j ? 0 : -1;
          });
          panels.forEach((p, j) => (p.hidden = i !== j));
          if (more && btn.dataset.url) more.href = btn.dataset.url;
        });
        btn.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const n = (i + (e.key === 'ArrowRight' ? 1 : btns.length - 1)) % btns.length;
          btns[n].focus();
          btns[n].click();
        });
      });
    });
  };

  // Rotating words
  const initRotators = (root) => {
    root.querySelectorAll('[data-w-rotator]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const words = [...el.querySelectorAll('.w-rotator__word')];
      if (words.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let i = 0;
      const speed = parseInt(el.dataset.speed || '2200', 10);
      setInterval(() => {
        const cur = words[i];
        i = (i + 1) % words.length;
        const next = words[i];
        cur.classList.remove('is-active');
        cur.classList.add('is-leaving');
        next.classList.remove('is-leaving');
        next.classList.add('is-active');
        setTimeout(() => cur.classList.remove('is-leaving'), 650);
      }, speed);
    });
  };

  const init = (root = document) => { initTabs(root); initRotators(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

// Lorenza-style reel carousel
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-lz-reels]').forEach((sec) => {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      const track = sec.querySelector('[data-lz-track]'); const cards = [...track.children];
      const dots = sec.querySelector('[data-lz-dots]');
      cards.forEach((c, i) => { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1)); b.onclick = () => go(i); dots.appendChild(b); });
      const center = () => { const mid = track.scrollLeft + track.clientWidth / 2; let best = 0, d = 1e9;
        cards.forEach((c, i) => { const cm = c.offsetLeft + c.offsetWidth / 2; const dd = Math.abs(cm - mid); if (dd < d) { d = dd; best = i; } });
        cards.forEach((c, i) => c.classList.toggle('is-center', i === best)); [...dots.children].forEach((b, i) => b.classList.toggle('is-active', i === best)); return best; };
      const go = (i) => { const c = cards[Math.max(0, Math.min(cards.length - 1, i))]; track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2 }); };
      sec.querySelector('[data-lz-prev]').onclick = () => go(center() - 1);
      sec.querySelector('[data-lz-next]').onclick = () => go(center() + 1);
      track.addEventListener('scroll', () => { clearTimeout(track._t); track._t = setTimeout(center, 60); });
      requestAnimationFrame(() => { go(Math.floor(cards.length / 2)); setTimeout(center, 300); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
